export default "__VITE_ASSET__DR7_LfnI__"